const routes = [
  {
    path: '/keycloak',
    name: 'keycloak',
    component: () => import('@/views/Keycloak/Keycloak')
  },
  {
    path: '/keycloak/identityprovider/:type/:id',
    name: 'keycloak.ip',
    component: () => import('@/views/Keycloak/IdentityProvider')
  }
]

export default routes
